<avn-page>
  <avn-ribbon fabIcons="action:settings" [title]="'dashboardScope.dashboard.ribbon.title' | transloco">
    <avn-ribbon-actions>
      <avn-ribbon-card
        *ngIf="remainingNewFeatureCount > 0"
        icon="av:new_releases"
        [title]="'dashboardScope.dashboard.new-feature-tour.ribbon-icon-text' | transloco"
        [count]="remainingNewFeatureCount"
        (actioned)="openNewFeatureTour()"
      >
      </avn-ribbon-card>
    </avn-ribbon-actions>
  </avn-ribbon>

  <avn-main avnScroll *ngIf="(isDashboardInitiated$ | async) || (isDashboardPending$ | async) === false" class="widget-container" data-e2e="widget-container">
    <avn-empty-data-message
      *ngIf="noWidgetsSelected$ | async"
      icon="device:widgets"
      [text]="'dashboardScope.dashboard.EMPTY_DATA.EMPTY_WIDGET_TEXT_30' | transloco"
      [subText]="'dashboardScope.dashboard.EMPTY_DATA.EMPTY_WIDGET_SUBTEXT_100' | transloco"
    >
    </avn-empty-data-message>
    <avn-grid [cols]="gridColumns" [gridRowHeight]="gridElementHeight$ | async">
      <ng-template [ampHasAnyPermissions]="widgetsPermissions.get(Widgets.DevicesHealth)">
        <ng-container *avnHideForDevices="['handset']">
          <div *ngIf="widgetVisible.get(Widgets.DevicesHealth)" avnGridElement [columnSpan]="columnPresets.deviceHealth" class="dashboard-widget-container">
            <avn-widget class="dashboard-device-health" data-e2e="dashboard-device-health" [name]="Widgets.DevicesHealth" [headingTitle]="'dashboardScope.dashboard.health.title' | transloco">
              <avn-pie
                [style.height.px]="300"
                [style.width.%]="100"
                [showDataLabels]="false"
                [innerSize]="'70%'"
                [selectionEnabled]="true"
                [data]="healthStatusDataSource"
                (dataClicked)="navigateToDeviceStatus($event.name)"
              >
                <avn-slice-chart-legend [layout]="'horizontal'" [verticalAlign]="'bottom'" [align]="'center'" [precision]="0"> </avn-slice-chart-legend>
                <avn-slice-chart-tooltip-formatter [labelValueType]="'value'" [precision]="0"> </avn-slice-chart-tooltip-formatter>
              </avn-pie>

              <p style="text-align: center" *ngIf="!!(deviceGroupName$ | async) && deviceCount">
                {{ 'dashboardScope.dashboard.health.group' | transloco }}: <strong>{{ deviceGroupName$ | async }}</strong> ({{ deviceCount }}
                {{ 'dashboardScope.dashboard.health.devices' | transloco }}).
              </p>
            </avn-widget>
          </div>
        </ng-container>
      </ng-template>

      <avn-count-card-grid [colMax]="3" [cardWidth]="100" [gap]="'10px'" avnGridElement [columnSpan]="columnPresets.numberCards">
        <ng-template [ampHasAnyPermissions]="widgetsPermissions.get(Widgets.DevicesSuccess)">
          <div *ngIf="widgetVisible.get(Widgets.DevicesSuccess)">
            <avn-count-card
              data-e2e="dashboard-success-devices"
              [title]="'deviceFields.DEVICE.ENUM.HEALTH_STATUS.OK' | transloco"
              [theme]="HealthStatusThemes[HealthStatusCode.OK]"
              [value]="numberCardPercentFormat(successDevicesDataSource.value)"
              [uom]="'%'"
              [footerText]="successDevicesDataSource.name"
              (click)="navigateToDeviceStatus('Ok')"
              [valueSize]="CountCardValueSize.lg"
            ></avn-count-card>
          </div>
        </ng-template>

        <ng-template [ampHasAnyPermissions]="widgetsPermissions.get(Widgets.DevicesErrors)">
          <div *ngIf="widgetVisible.get(Widgets.DevicesErrors)">
            <avn-count-card
              data-e2e="dashboard-error-devices"
              [title]="'deviceFields.DEVICE.ENUM.HEALTH_STATUS.ERROR' | transloco"
              [theme]="HealthStatusThemes[HealthStatusCode.ERROR]"
              [value]="numberCardPercentFormat(errorDevicesDataSource.value)"
              [uom]="'%'"
              [footerText]="errorDevicesDataSource.name"
              (click)="navigateToDeviceStatus('Error')"
              [valueSize]="CountCardValueSize.lg"
            ></avn-count-card>
          </div>
        </ng-template>

        <ng-template [ampHasAnyPermissions]="widgetsPermissions.get(Widgets.DevicesWarning)">
          <div *ngIf="widgetVisible.get(Widgets.DevicesWarning)">
            <avn-count-card
              data-e2e="dashboard-warning-devices"
              [title]="'deviceFields.DEVICE.ENUM.HEALTH_STATUS.WARNING' | transloco"
              [theme]="HealthStatusThemes[HealthStatusCode.WARNING]"
              [value]="numberCardPercentFormat(warningDevicesDataSource.value)"
              [uom]="'%'"
              [footerText]="warningDevicesDataSource.name"
              (click)="navigateToDeviceStatus('Warning')"
              [valueSize]="CountCardValueSize.lg"
            ></avn-count-card>
          </div>
        </ng-template>

        <ng-template [ampHasAnyPermissions]="widgetsPermissions.get(Widgets.DevicesUnreachable)">
          <div *ngIf="widgetVisible.get(Widgets.DevicesUnreachable)">
            <avn-count-card
              data-e2e="dashboard-unreachable-devices"
              [title]="'deviceFields.DEVICE.ENUM.HEALTH_STATUS.UNREACHABLE' | transloco"
              [theme]="HealthStatusThemes[HealthStatusCode.UNREACHABLE]"
              [value]="numberCardPercentFormat(unreachableDevicesDataSource.value)"
              [uom]="'%'"
              [footerText]="unreachableDevicesDataSource.name"
              (click)="navigateToDeviceStatus('Unreachable')"
              [valueSize]="CountCardValueSize.lg"
            ></avn-count-card>
          </div>
        </ng-template>

        <ng-template [ampHasAnyPermissions]="widgetsPermissions.get(Widgets.DevicesNotMonitored)">
          <div *ngIf="widgetVisible.get(Widgets.DevicesNotMonitored)">
            <avn-count-card
              data-e2e="dashboard-not-monitored-devices"
              [title]="'deviceFields.DEVICE.ENUM.HEALTH_STATUS.NOT_MONITORED' | transloco"
              [theme]="HealthStatusThemes[HealthStatusCode.NOT_MONITORED]"
              [value]="numberCardPercentFormat(notMonitoredDevicesDataSource.value)"
              [uom]="'%'"
              [footerText]="notMonitoredDevicesDataSource.name"
              (click)="navigateToDeviceStatus('Not Monitored')"
              [valueSize]="CountCardValueSize.lg"
            ></avn-count-card>
          </div>
        </ng-template>

        <ng-template [ampHasAnyPermissions]="widgetsPermissions.get(Widgets.UpTime)">
          <div *ngIf="widgetVisible.get(Widgets.UpTime)">
            <avn-count-card
              data-e2e="dashboard-up-time"
              [title]="'dashboardScope.dashboard.uptime.title' | transloco"
              [theme]="THEME_TYPES.PRIMARY"
              [value]="uptimeFormat(cpuUptime$ | async)"
              [footerText]="translateService.selectTranslate('dashboardScope.dashboard.uptime.label') | async"
              [valueSize]="CountCardValueSize.lg"
            ></avn-count-card>
          </div>
        </ng-template>
      </avn-count-card-grid>

      <ng-template [ampHasAnyPermissions]="widgetsPermissions.get(Widgets.ServerOverview)">
        <ng-container *avnHideForDevices="['handset']">
          <div *ngIf="widgetVisible.get(Widgets.ServerOverview)" avnGridElement [columnSpan]="columnPresets.serverOverview" class="dashboard-widget-container">
            <avn-widget class="dashboard-server-overview" data-e2e="dashboard-server-overview" [name]="Widgets.ServerOverview" [headingTitle]="'dashboardScope.dashboard.server.title' | transloco">
              <amp-server-overview></amp-server-overview>
            </avn-widget>
          </div>
        </ng-container>
      </ng-template>

      <ng-template [ampHasAnyPermissions]="widgetsPermissions.get(Widgets.ContentStatistics)">
        <div *ngIf="widgetVisible.get(Widgets.ContentStatistics)" avnGridElement [columnSpan]="columnPresets.contentStats" class="dashboard-widget-container">
          <avn-widget
            class="dashboard-content-statistics"
            data-e2e="dashboard-content-statistics"
            [name]="Widgets.ContentStatistics"
            [headingTitle]="'dashboardScope.dashboard.content.title' | transloco"
          >
            <amp-content-overview></amp-content-overview>
          </avn-widget>
        </div>
      </ng-template>

      <ng-template [ampHasAnyPermissions]="widgetsPermissions.get(Widgets.SystemLoad)">
        <div *ngIf="widgetVisible.get(Widgets.SystemLoad)" avnGridElement [columnSpan]="columnPresets.timeSeries" class="dashboard-widget-container">
          <avn-widget class="dashboard-system-load" data-e2e="dashboard-system-load" [name]="Widgets.SystemLoad" [headingTitle]="'dashboardScope.dashboard.system-load.title_30' | transloco">
            <amp-server-overview-widget
              [data]="systemLoadData"
              [yAxisLabel]="cpuCoreCount$ | async | i18nPlural: systemLoadYAxisLabels | transloco: { coreCount: (cpuCoreCount$ | async) }"
              [yAxisSoftMax]="cpuCoreCount$ | async"
              [yAxisTickInterval]="1"
              [dataUnit]="''"
              [precision]="2"
              [valueFormatter]="formatValue"
              [thresholdThemes]="cpuUsageThresholdTheme$ | async"
            >
            </amp-server-overview-widget>
          </avn-widget>
        </div>
      </ng-template>

      <ng-template [ampHasAnyPermissions]="widgetsPermissions.get(Widgets.MonitoringSpeed)">
        <div *ngIf="widgetVisible.get(Widgets.MonitoringSpeed)" avnGridElement [columnSpan]="columnPresets.timeSeries" class="dashboard-widget-container">
          <avn-widget
            class="dashboard-monitoring-speed"
            data-e2e="dashboard-monitoring-speed"
            [name]="Widgets.MonitoringSpeed"
            [headingTitle]="'dashboardScope.dashboard.monitoring-speed.title' | transloco"
          >
            <amp-monitoring-speed [valueFormatter]="formatValue"></amp-monitoring-speed>
          </avn-widget>
        </div>
      </ng-template>

      <ng-template [ampHasAnyPermissions]="widgetsPermissions.get(Widgets.BandwidthUsage)">
        <div *ngIf="widgetVisible.get(Widgets.BandwidthUsage)" avnGridElement [columnSpan]="columnPresets.timeSeries" class="dashboard-widget-container">
          <avn-widget class="dashboard-bandwidth-usage" data-e2e="dashboard-bandwidth-usage" [name]="Widgets.BandwidthUsage" [headingTitle]="'dashboardScope.dashboard.bw-usage.title' | transloco">
            <amp-server-overview-widget [data]="bandwidthUsageData" [dataUnit]="'Kb/s'" [yAxisLabel]="'Kb/s'" [yAxisSoftMax]="100" [precision]="2" [valueFormatter]="formatBandwidthUsageValue">
            </amp-server-overview-widget>
          </avn-widget>
        </div>
      </ng-template>

      <ng-template [ampHasAnyPermissions]="widgetsPermissions.get(Widgets.MemUsage)">
        <div *ngIf="widgetVisible.get(Widgets.MemUsage)" avnGridElement [columnSpan]="columnPresets.timeSeries" class="dashboard-widget-container">
          <avn-widget class="dashboard-memory-usage" data-e2e="dashboard-memory-usage" [name]="Widgets.MemUsage" [headingTitle]="'dashboardScope.dashboard.mem-usage.title' | transloco">
            <amp-server-overview-widget
              [data]="memoryUsageData"
              [yAxisLabel]="'%'"
              [yAxisSoftMax]="100"
              [dataUnit]="'%'"
              [precision]="2"
              [valueFormatter]="formatValue"
              [thresholdThemes]="thresholdTheme"
            >
            </amp-server-overview-widget>
          </avn-widget>
        </div>
      </ng-template>

      <ng-template [ampHasAnyPermissions]="widgetsPermissions.get(Widgets.DiskUsage)">
        <div *ngIf="widgetVisible.get(Widgets.DiskUsage)" avnGridElement [columnSpan]="columnPresets.timeSeries" class="dashboard-widget-container">
          <avn-widget class="dashboard-disk-usage" data-e2e="dashboard-disk-usage" [name]="Widgets.DiskUsage" [headingTitle]="'dashboardScope.dashboard.disk-usage.title' | transloco">
            <amp-server-overview-widget
              [data]="diskUsageData"
              [dataUnit]="'%'"
              [yAxisLabel]="'%'"
              [yAxisSoftMax]="100"
              [precision]="2"
              [valueFormatter]="formatValue"
              [thresholdThemes]="thresholdTheme"
            >
            </amp-server-overview-widget>
          </avn-widget>
        </div>
      </ng-template>

      <ng-template *avnHideForDevices="['handset']" [ampHasAnyPermissions]="widgetsPermissions.get(Widgets.ProcessDetails)">
        <div *ngIf="widgetVisible.get(Widgets.ProcessDetails)" avnGridElement [columnSpan]="columnPresets.processDetails" debounceTime="300">
          <avn-widget
            class="dashboard-process-details"
            data-e2e="dashboard-process-details"
            [name]="Widgets.ProcessDetails"
            [headingTitle]="'dashboardScope.dashboard.process-details.title' | transloco"
          >
            <amp-server-process></amp-server-process>
          </avn-widget>
        </div>
      </ng-template>
    </avn-grid>
  </avn-main>
</avn-page>
